import "./css/course.css"
import HomeMenu from "./../elemets/homeMenu";
import Footer from "./../footer/footer"
import { useState, useEffect } from "react";
import Test from "./../elemets/test";
import Video from "./../elemets/video";
import TextNotes from "./../elemets/textnotes";

// टैब्स का डेटा (इससे हार्डकोडिंग की समस्या खत्म हो जाएगी)
const TABS = [
    { id: "Test", label: "Test", component: <Test /> },
    { id: "Video Notes", label: "Videos", component: <Video /> },
    { id: "NoteBook", label: "TextBook", component: <TextNotes /> }
];

const Course = () => {
    const [activeButton, setActiveButton] = useState("Test");

    const updateActiveButton = (buttonId) => {
        sessionStorage.setItem("activeButton", buttonId);
        setActiveButton(buttonId);
    }

    useEffect(() => {
        const getActiveButton = sessionStorage.getItem("activeButton");
        if (getActiveButton) {
            setActiveButton(getActiveButton);
        }
    }, [])

    return (
        <div className="coursePageOuterWrapper">
            
            {/* Header (Top Navigation) */}
            <div className="coursePageMainMenuContainer">
                <HomeMenu />
            </div>

            {/* Main Course Content Wrapper */}
            <div className="coursePageWrapper">
                <div className="courseMainContainer">
                    
                    {/* Sidebar / Top Tabs */}
                    <div className="CourseChangeButton" role="tablist">
                        {TABS.map((tab) => (
                            <button 
                                key={tab.id}
                                role="tab"
                                aria-selected={activeButton === tab.id}
                                className={activeButton === tab.id ? "active" : ""} 
                                onClick={() => updateActiveButton(tab.id)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* Content Area */}
                    <div className="courseContent" role="tabpanel">
                        {TABS.find(tab => tab.id === activeButton)?.component}
                    </div>
                </div>
            </div>

            <Footer />
            
        </div>
    );
};

export default Course;